const normalizePaymentText = value =>
	String(value || "")
		.toLowerCase()
		.replace(/[\s_\-/（）()，,、·.:：]/g, "");

const PAY_AREA_KEYS = [
	{ key: "china", names: ["china", "中国", "中國"] },
	{
		key: "hongKongMacau",
		names: ["hongkongmacau", "香港澳门", "香港澳門", "香港/澳門", "香港/澳门"],
	},
	{ key: "malaysia", names: ["malaysia", "马来西亚", "馬來西亞"] },
	{ key: "singapore", names: ["singapore", "新加坡"] },
	{
		key: "globalOtherUnknown",
		names: ["globalotherunknown", "otherunknown", "全球其他未知"],
	},
	{ key: "taiwan", names: ["taiwan", "台湾", "台灣"] },
	{ key: "indonesia", names: ["indonesia", "印尼", "印度尼西亚", "印度尼西亞"] },
	{ key: "vietnam", names: ["vietnam", "越南"] },
	{ key: "thailand", names: ["thailand", "泰国", "泰國"] },
];

const PAY_METHOD_KEYS = [
	{ key: "taiwanLinePay", names: ["台灣LinePay支付", "台湾LinePay支付"] },
	{
		key: "newebPay",
		names: ["藍新支付（超商、條碼等等）", "蓝新支付（超商、条码等等）"],
	},
	{ key: "tngWallet", names: ["TNG電子錢包", "TNG电子钱包"] },
	{ key: "publicBank", names: ["Public銀行", "Public银行"] },
	{ key: "maybank", names: ["Maybank銀行", "Maybank银行"] },
	{ key: "ocbcBank", names: ["Ocbc銀行", "Ocbc银行", "OCBC銀行", "OCBC银行"] },
	{ key: "macauCreditCard", names: ["澳門信用卡", "澳门信用卡"] },
	{ key: "globalCreditCard", names: ["全球信用卡支付"] },
	{ key: "wechatPay", names: ["微信支付", "WeChat Pay"] },
	{ key: "alipay", names: ["支付宝", "支付寶", "Alipay"] },
	{ key: "stripe", names: ["Stripe"] },
	{ key: "paypal", names: ["PayPal"] },
	{ key: "myCard", names: ["MyCard"] },
	{ key: "linePay", names: ["LinePay"] },
	{ key: "points", names: ["點數", "点数", "Points"] },
	{ key: "creditCard", names: ["信用卡", "Credit Card"] },
];

const getPayAreaKey = name => {
	const normalizedName = normalizePaymentText(name);
	const match = PAY_AREA_KEYS.find(area =>
		area.names.some(item => normalizedName === normalizePaymentText(item))
	);
	return match?.key || "";
};

const getPayMethodKey = item => {
	const normalizedName = normalizePaymentText(item?.name);
	const match = PAY_METHOD_KEYS.find(method =>
		method.names.some(name => normalizedName === normalizePaymentText(name))
	);
	return match?.key || "";
};

const translateOrOriginal = (t, key, original) => {
	if (!key) return original || "";
	const value = t(key);
	return value === key ? original || "" : value;
};

export const displayPayAreaName = (name, t) => {
	const key = getPayAreaKey(name);
	return translateOrOriginal(t, key ? `user.pc.wallet.payAreas.${key}` : "", name);
};

export const displayPayMethodName = (item, t) => {
	const key = getPayMethodKey(item);
	return translateOrOriginal(t, key ? `user.pc.wallet.payMethods.${key}` : "", item?.name);
};
